import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AdminResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const admin = {
    record(data: typeof Requests.Admin.Record.Input) {
        return post<typeof data, AdminResponseTypes.Record>(`/admin/record`, data);
    },
    create(data: typeof Requests.Admin.Create.Input) {
        return post<typeof data>("/admin/create", data);
    },
    obtain(id: string) {
        return get<AdminResponseTypes.Obtain>(`/admin/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/admin/delete/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Admin.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/admin/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
